import axios from 'axios'

/** @type {string} */
const apiUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:8000/api'

/** Laravel app origin without `/api` — used for Sanctum CSRF cookie */
export const appOrigin = apiUrl.replace(/\/api\/?$/, '')

export const api = axios.create({
  baseURL: apiUrl,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
  withXSRFToken: true,
  timeout: 15000,
})

/** @type {number | null} */
let activeBranchId = null

/**
 * @param {number | null} branchId
 */
export function setApiBranchId(branchId) {
  activeBranchId = branchId
}

api.interceptors.request.use((config) => {
  if (activeBranchId) {
    config.headers['X-Branch-Id'] = String(activeBranchId)
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (import.meta.env.DEV && error.response) {
      const url = error.config?.url ?? ''
      const isExpectedGuestAuth = error.response.status === 401 && url.includes('/auth/me')
      if (!isExpectedGuestAuth) {
        console.warn('[api]', error.response.status, url, error.response.data)
      }
    }
    return Promise.reject(error)
  },
)

/**
 * Sanctum SPA — call before login POST (Phase 1).
 * @returns {Promise<void>}
 */
export async function ensureCsrfCookie() {
  await axios.get(`${appOrigin}/sanctum/csrf-cookie`, {
    withCredentials: true,
    withXSRFToken: true,
    headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
  })
}

/**
 * @returns {Promise<import('@/types/api').HealthResponse>}
 */
export async function fetchHealth() {
  const { data } = await api.get('/health')
  return data
}

export function getApiUrl() {
  return apiUrl
}
